import { ChangeDetectionStrategy, Component } from '@angular/core'
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { ConversationsWaitingBadgeComponent } from '@app/support/conversations/conversations-waiting-badge.component'
import { ConnectionBannerComponent } from './connection-banner/connection-banner.component'

@Component({
  selector: 'atlas-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive, ConnectionBannerComponent, ConversationsWaitingBadgeComponent, TranslatePipe],
  template: `
    <nav class="atlas-nav">
      <span class="brand">Atlas</span>
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">{{ 'ATLAS.PAGES.ENVIRONMENTS' | translate }}</a>
      <a routerLink="/dashboard" routerLinkActive="active">{{ 'ATLAS.PAGES.TODAY' | translate }}</a>
      <a routerLink="/analytics" routerLinkActive="active">{{ 'ATLAS.PAGES.ANALYTICS' | translate }}</a>
      <a routerLink="/conversations" routerLinkActive="active" class="with-badge"
        >{{ 'ATLAS.PAGES.CONVERSATIONS' | translate }} <app-conversations-waiting-badge></app-conversations-waiting-badge
      ></a>
      <a routerLink="/models" routerLinkActive="active">{{ 'ATLAS.PAGES.MODELS' | translate }}</a>
      <a routerLink="/experiments" routerLinkActive="active">{{ 'ATLAS.PAGES.EXPERIMENTS' | translate }}</a>
      <a routerLink="/utilities" routerLinkActive="active">{{ 'ATLAS.PAGES.UTILITIES' | translate }}</a>
    </nav>
    <atlas-connection-banner></atlas-connection-banner>
    <router-outlet></router-outlet>
  `,
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent {}
